import { createContext, type ReactNode } from 'react';
import type { Breadcrumb } from '@ps-refarch-ux/neon';
import type { PageHeaderAction } from '@/components/PageHeader/page-header';

export interface PageConfig {
  breadcrumbs: Array<Breadcrumb>;
  breadcrumbsId: string;
  title: string;
  action?: PageHeaderAction;
  /** Rendered beside the primary action in the header (e.g. Export, Import) */
  secondaryActions?: ReactNode;
  /** Optional key so layout updates when secondary actions change (e.g. when data loads). Serialized in usePageConfig. */
  secondaryActionsKey?: string;
  description?: string;
  onBack?: () => void;
  backLabel?: string;
}

export interface PageConfigContextValue {
  config: PageConfig | null;
  setConfig: (config: PageConfig) => void;
}

export const PageConfigContext = createContext<PageConfigContextValue | null>(null);
